







































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';

const TITLE_SLUG = 'shop.components.order_conflict.title';
const DESCRIPTION_SLUG = 'shop.components.order_conflict.description';
const RELOAD_SLUG = 'shop.components.order_conflict.reload';

@Component
export default class OrderConflictModal extends Vue {
    @Ref('order-conflict-dialog')
    dialog!: HTMLDialogElement;

    get title(): string {
        return this.$te(TITLE_SLUG)
            ? (this.$t(TITLE_SLUG) as string)
            : 'Session no longer valid';
    }

    get description(): string {
        return this.$te(DESCRIPTION_SLUG)
            ? (this.$t(DESCRIPTION_SLUG) as string)
            : 'Your session validation has already been used for an earlier order and cannot be used again.';
    }

    get cta(): string {
        return this.$te(RELOAD_SLUG)
            ? (this.$t(RELOAD_SLUG) as string)
            : 'Try again';
    }

    mounted() {
        this.dialog.showModal();
    }

    reload(): void {
        window.location.reload();
    }
}
